import { render, staticRenderFns } from "./shop_products.vue?vue&type=template&id=feca6014&"
import script from "./shop_products.vue?vue&type=script&lang=js&"
export * from "./shop_products.vue?vue&type=script&lang=js&"
import style0 from "./shop_products.vue?vue&type=style&index=0&id=feca6014&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports